import { IconDownload, IconLoader2 } from '@tabler/icons-react'
import { format } from 'date-fns'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useGetLatestCalendarDate } from 'src/API/rest.forecast_calender'
import { useReportAPIs } from 'src/API/rest.reports'
import { useStatesAPI } from 'src/API/rest.states'
import { ButtonIconSquare } from 'src/components/buttons'
import { ErrorBoxStandard } from 'src/components/standard.errorbox'
import { InputStandard } from 'src/components/standard.input'
import { SelectStandard } from 'src/components/standard.select'
import { TypographyH2 } from 'src/components/typography'
import { RootState } from 'src/redux/store'
import { toast } from 'src/shadcn/ui/use-toast'

export default function Rollingforcast_accuracy_report() {
    const currentDate = new Date();
    const [selectedDate, setSelectedDate] = useState(
        currentDate.toISOString().substring(0, 7) // Format: YYYY-MM
    );
    const FormatedSelectedDate = selectedDate ? format(new Date(selectedDate + '-01'), 'yyyy-MM-dd') : null;
    const {
        isErrorlatestCalendarDate,
        isFetchedlatestCalendarDate,
        isFetchinglatestCalendarDate,
        isLoadinglatestCalendarDate,
        latestCalendarDate,
        refetchlatestCalendarDate
    } = useGetLatestCalendarDate({
        trigger: true
    })


    useEffect(
        () => {
            if (latestCalendarDate?.date) {
                setSelectedDate(format(latestCalendarDate?.date, 'yyyy-MM'))
            }
        }, [isLoadinglatestCalendarDate]
    )
    const {
        downloadRollingForecastAccuracyReport,
        isdownloadRollingForecastAccuracyReport
    } = useReportAPIs()

    const {
        states,
        isLoading: isLoadingState,
        isError: isErrorState,
        isFetching: isFetchingState
    } = useStatesAPI({
        trigger: true
    });


    if (isErrorlatestCalendarDate && !isFetchinglatestCalendarDate) {
        return (
            <div className=' grow flex flex-col items-center '>
                <ErrorBoxStandard
                    onRetry={refetchlatestCalendarDate}
                />
            </div>
        )
    }

    return (
        <div className=' grow  flex flex-col overflow-auto items-center '>
            <div className=' grow flex flex-col overflow-hidden bg-white dark:bg-vstargray-900  rounded-md w-full text-center'>
                <div className=' grow flex flex-col overflow-auto p-2 '>
                    <TypographyH2>Rolling Forecast Accuracy Report</TypographyH2>
                    <div className=' flex gap-2 '>

                        <InputStandard
                            title='Date'
                            placeholder='Date'
                            type='month'
                            onChange={(e) => {
                                setSelectedDate(e.target.value)
                            }}
                            disabled={isFetchinglatestCalendarDate}
                            value={selectedDate || ''}
                        />

                    </div>

                </div>
                <div className=' grow flex flex-col justify-center items-center  w-min mx-auto mt-8'>

                    <ButtonIconSquare
                        className=' mx-auto mb-5'
                        icon={isdownloadRollingForecastAccuracyReport ? <IconLoader2 className='animate-spin' /> : <IconDownload />}
                        onClick={async () => {



                            const response = await downloadRollingForecastAccuracyReport({
                                date: FormatedSelectedDate,
                            })
                            if (response.success === false) {
                                toast({
                                    title: 'Error',
                                    description: response.message
                                })
                            }
                        }}
                        variant='secondary'
                        text='Download'
                    />
                </div>
            </div>
        </div>

    )
}
